<app-contact-information [from]="'profile'" (submitData) = "onSubmit($event)"></app-contact-information>
<!-- <app-profile-information></app-profile-information> -->